module.exports = __webpack_public_path__ + "static/media/safe-checkout.62279867.jpg";